<a class="draft-card" [routerLink]="draftUrl" [attr.data-cy]="'draft-card-' + draft.draftPortfolioId">
    <div class="draft-label">
        {{ 'investments.draftCard.label' | translate }}
    </div>
    <div class="draft-card-layout">
        <div class="draft-card-header">
            <liberro-avatar-photo-tagged [portfolioDetail]="{ portfolioType: draft.portfolioType}" size="44"></liberro-avatar-photo-tagged>
            <div class="name-wrapper">
                <div class="name" [attr.data-cy]="'draft-card-name-' + draft.draftPortfolioId">
                    {{ draft.name }}
                </div>
            </div>
            <liberro-badge
                variant="danger"
                [label]="('investments.draftCard.expiresIn' | translate) + (draft.autoExpiryTime | dayDiff)"
                [unbreakable]="true"
                [attr.data-cy]="'draft-card-expiry-' + draft.draftPortfolioId"
            ></liberro-badge>
        </div>
        <div class="detail-layout">
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.totalYearsToInvest' | translate }}
                </div>
                <div class="value" [attr.data-cy]="'draft-card-years-' + draft.draftPortfolioId">
                    {{ draft.totalYearsToInvest | yearsTranslate }}
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.regularDeposit' | translate }}
                </div>
                <div class="value" [attr.data-cy]="'draft-card-regular-deposit-' + draft.draftPortfolioId">
                    {{ draft.regularDeposit | price }}
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.initialDeposit' | translate }}
                </div>
                <div class="value" [attr.data-cy]="'draft-card-initial-deposit-' + draft.draftPortfolioId">
                    {{ draft.initialDeposit | price }}
                </div>
            </div>
            <div class="detail-row">
                <div class="label">
                    {{ 'investments.draftCard.weeksBetweenInvestments' | translate }}
                </div>
                <div class="value" [attr.data-cy]="'draft-card-frequency-' + draft.draftPortfolioId">
                    {{ ('newInvestment.settings.frequency.' + (draft.weeksBetweenInvestments | fullFrequency)) | translate }}
                </div>
            </div>
        </div>
    </div>
</a>